import React, { useRef, useState, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CInput,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CRow,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { users } from "../../assets/data/users.js";
import { useHistory } from "react-router-dom";
import ApiUser from "../../api/ApiUser.js";
import Swal from "sweetalert2";
import AlertError from "../../reusable/AlertError.js";
const TokenPage = () => {
  const history = useHistory();

  const formInput = useRef(null);
  const [error, seterror] = useState();

  const dispatch = useDispatch();
  const userState = useSelector((state) => state.user);

  const registerToken = async (e) => {
    e.preventDefault();
    const { token } = e.target;
    Swal.showLoading();
    try {
      const result = await ApiUser.registerToken({ token: token.value });
      if (result.status == 200) {
        Swal.close();
        history.push("/login");
      }
    } catch (error) {
      Swal.close();
      const { data } = error.response;
      AlertError("", data?.message);
    }
  };

  return (
    <div className="c-app c-default-layout bg-dark flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md="6">
            <CCardGroup>
              <CCard className="p-4 border">
                <CCardBody>
                  <form ref={formInput} onSubmit={registerToken}>
                    <h1>Register Token</h1>
                    <p className="text-muted">Register with your token</p>
                    <CInputGroup className="mb-3">
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <CIcon name="cil-lock-locked" />
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CInput
                        required
                        type="text"
                        name="token"
                        placeholder="Token"
                        autoComplete={"off"}
                      />
                    </CInputGroup>
                    <CRow>
                      <CCol xs="6">
                        <CButton
                          // onClick={login}
                          type="submit"
                          color="primary"
                          className="px-4"
                        >
                          Register
                        </CButton>
                      </CCol>
                    </CRow>
                  </form>
                  <label className="text-danger mt-3">{error}</label>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

export default TokenPage;
